import ResourceService from "./resource.service";

class ModelService extends ResourceService {
  static get resource() {
    return "made";
  }
}

export default ModelService;
